import React, { useContext, useState } from 'react';

import { Accordion, Button, CloseButton } from 'react-bootstrap';
import { AiOutlineLogout } from 'react-icons/ai';
import { NavLink } from 'react-router-dom';

import routes from '../../routes';
import { NewContext } from '../../Context/NewContext';

import './sidebar.css';

const Sidebar = () => {
  const [activeAccordian, setActiveAccordian] = useState(`/${window.location.hash.split('/')[1]}`);
  const { toggleSidebar, setToggleSidebar, setConfirmationModalShow, setDeleteUpdateYes, setSearch, setFilterDropdown, setCheckedValues } = useContext(NewContext);
  const defaultFilterDropdown = {
    isAnimated: "",
    isAvaiableDiffKey: "",
    isTop: "",
    isLatest: "",
    isHot: "",
    isActive: "",
    isPremium: "",
  };
  return (
    <>
      <div className={`sidebar-canvas d-xl-none vh-100 position-absolute m-auto ${toggleSidebar ? 'd-block' : 'd-none'}`} onClick={() => setToggleSidebar(false)}></div>
      <div className={`${toggleSidebar ? 'sidebar-tanslate-x-0' : "sidebar-tanslate-x-100"} sidebar bg-dark text-white p-3`}>
        <div className='sidebar-header d-flex justify-content-between align-items-center pb-4'>
          <h5>Emoji Keyboard</h5>
          <Button variant='danger' className='ms-2 px-2 d-none d-xl-block' onClick={() => { setDeleteUpdateYes("logout"); setConfirmationModalShow(true); }}>
            {/* <span className='me-2 d-none d-xl-inline'>Logout</span> */}
            <AiOutlineLogout size={"25px"} />
          </Button>
          <div className="close-sidebar d-block d-xl-none" onClick={() => setToggleSidebar(!toggleSidebar)}><CloseButton variant='white' /></div>
        </div>
        <div className='sidebar-body'>
          <ul className='mb-0 list-unstyled'>
            <Accordion flush className='overflow-hidden'>
              {
                routes.sidebarRoutes.map(({ name, path, layout, icon, subRoutes }, i) => (
                  <li className='mb-2 overflow-hidden' key={i} style={{ borderRadius: `0.375rem` }}>
                    {
                      subRoutes && subRoutes.length > 0 ?
                        <Accordion.Item eventKey={i} className="border-0 overflow-hidden bg-transparent">
                          <Accordion.Button className={`overflow-hidden ${subRoutes.find(_ele => _ele.path === activeAccordian) ? `active-accordion` : ``}`}>
                            <span className='me-2'>{icon}</span>
                            <span className='text-capitalize'>{name}</span>
                          </Accordion.Button>
                          <Accordion.Body className='p-0 mt-1'>
                            {
                              subRoutes.map(({ name, path, icon }, i) => (
                                <NavLink to={path} key={i}>
                                  {
                                    ({ isActive }) => (
                                      <Button variant={`${isActive ? 'primary' : 'light'}`} className={`w-100 sidebar-route-btn text-start d-flex align-items-center rounded-0`} onClick={() => { setFilterDropdown(defaultFilterDropdown); setCheckedValues([]); setSearch(""); setActiveAccordian(path); setToggleSidebar(false) }}>
                                        <span className='me-2'>{icon}</span>
                                        <span className='text-capitalize'>{name}</span>
                                      </Button>
                                    )
                                  }
                                </NavLink>
                              ))
                            }
                          </Accordion.Body>
                        </Accordion.Item>
                        :
                        <NavLink to={path}>
                          {
                            ({ isActive }) => (
                              <Button variant={`${isActive ? 'primary' : 'light'}`} className={`w-100 sidebar-route-btn text-start d-flex align-items-center`} onClick={() => { setFilterDropdown(defaultFilterDropdown); setCheckedValues([]); setSearch(""); setActiveAccordian(false); setToggleSidebar(false); }}>
                                <span className='me-2'>{icon}</span>
                                <span className='text-capitalize'>{name}</span>
                              </Button>
                            )
                          }
                        </NavLink>
                    }
                  </li>
                ))
              }
            </Accordion>
          </ul>
        </div>
      </div>
    </>
  )
}

export default Sidebar